// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/fonts/ttf/Courier-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/fonts/ttf/Courier-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/fonts/ttf/Courier-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;

  --px-15: 15px;
  --px-30: 30px;

  /* 🎨 메인 컬러 (푸른 계열) */
  --main-color: #5e62e5;
  --main-color-light: #5a60fe; /* 기존 main-color1, main-color2, main-color7 */
  --main-color-alt: #4a4ef5;    /* 기존 main-color4 */
  --main-color-accent: #7377f7; /* 기존 main-color5, main-color8 */
  --main-color-dark: #373a6a;   /* 기존 main-color6 */

  /* ⚫ 검정/회색 계열 최적화 */
  --color-black: #000;           /* 기존 black0 */
  --color-darkest-gray: #121212;  /* 기존 black1, black6, black8 */
  --color-dark-gray: #272a2f;     /* 기존 black5, black7 */
  --color-gray: #3e3d3e;          /* 기존 black2~4, black9~11 */
  --color-light-gray: #8b8b8b;    /* 기존 black14, black16~18, black20 */
  --color-charcoal: #1c1e23;      /* 기존 black12, black13, black15 */
  --color-black-brown: #221E18;   /* 기존 black21 */
  --color-black-muted: #43433b;   /* 기존 black22 */

  /* 🌫 반투명 검정 */
  --color-black-opacity: rgba(0, 0, 0, 0.5); /* 기존 black-op0 */
  --color-black-opacity-dark: #181818d4;     /* 기존 black-op2 */
  --color-black-opacity-light: #33333399;    /* 기존 black-op3 */

  /* ⚪ 밝은색 계열 */
  --color-white: #fff;
  --color-light-gray-bg: #f1f1f1; /* 기존 light2 */

  /* 🟡 노랑 계열 */
  --color-yellow: #F5AC1D; /* 기존 yellow0, yellow2 */
  --color-orange: #F28C01; /* 기존 yellow1 */
}

.ratio {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.App {
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: var(--color-black);
  color: var( --color-white);
  box-sizing: border-box;
}

* {
  box-sizing: border-box;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
          user-select: none;
}

*::-webkit-scrollbar {
  display: none;
}

html,
body {
  height: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
  touch-action: none;
}

a {
  text-decoration: none;
  color: inherit;
}

.message {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--color-black-opacity);
  z-index: 1000;
}

.message-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  min-width: 300px;
  max-width: calc(100% - 40px);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 15px;
  padding: 15px 20px;
  z-index: 100;
  color: var( --color-white);
}

.message-modal.copy {
  background-color: var(--color-darkest-gray);
  border: 1px solid var(--main-color-light);
}

.loading {
  width: 100%;
  height: 100vh;
  position: relative;
  background: var( --color-black);
  animation: splash_img .7s ease-in-out;
}

@keyframes splash_img {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.loading .img {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  width: 100%;
}

.loading-3 {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  font-size: 12px;
  font-weight: 500;
  width: 80%;
}

.loading-4 {
  width: 100%;
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  font-weight: 500;
}

.loading-5 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.airdrop-text {
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  font-weight: 500;
}

.loading-5-1 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  background-color: var(--color-gray);
  border: 1px solid var(--color-gray);
  border-radius: 50%;
  font-size: 23px;
}

.buy-modal {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  min-width: 300px;
  max-width: calc(100% - 40px);
  /* height: 60px; */
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 13px;
  font-weight: 500;
  padding: 15px 15px;
  color: var( --color-white);
  font-weight: 500;
  z-index: 20000;
}

.buy-modal.copy {
  border: 1px solid var(--color-gray);
  background-color: var(--color-dark-gray);
  box-shadow: 0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a;
  animation: Modal_opacityIn .4s ease-in-out;
}

@keyframes Modal_opacityIn {
  from {
    opacity: 0;
    transform: translate(-50%, -20px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0px);
  }
}

.fontNumber {
  font-family: "Courier-Bold";
}

@font-face {
  font-family: 'Courier-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Courier-BoldItalic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Courier-Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: bold;
  font-style: normal;
}

.loading-4-1 {
  width: 150px;
  margin: 0 auto;
  padding: 8px 12px;
  background-color: var(--color-darkest-gray);
  border: 2px solid var(--color-yellow);
  color: var(--color-yellow);
  font-weight: bold;
  font-size: 18px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 15px 3px var(--color-yellow);
}

.airdrop-text-1 {
  margin: 0 auto;
  /* padding: 8px 10px; */
  background-color: var(--color-darkest-gray);
  border: 2px solid var(--color-yellow);
  color: var(--color-yellow);
  font-weight: bold;
  font-size: 15px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 15px 3px var(--color-yellow);
}

.web {
  /* width: 100vw; */
  height: 100vh;
  padding: 20px;
  background-color: var( --color-black);
  display: flex;
  align-items: center;
  justify-content: center;
}

.web-box {}

.web-qr {
  width: 240px;
  height: 240px;
  padding: 15px;
  border-radius: 10px;
  background-color: var( --color-white);
  margin: 20px 0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;;EAEnB,aAAa;EACb,aAAa;;EAEb,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B,EAAE,6CAA6C;EAC1E,yBAAyB,KAAK,mBAAmB;EACjD,4BAA4B,EAAE,gCAAgC;EAC9D,0BAA0B,IAAI,mBAAmB;;EAEjD,mBAAmB;EACnB,mBAAmB,YAAY,cAAc;EAC7C,6BAA6B,GAAG,8BAA8B;EAC9D,0BAA0B,MAAM,sBAAsB;EACtD,qBAAqB,WAAW,2BAA2B;EAC3D,2BAA2B,KAAK,oCAAoC;EACpE,yBAAyB,OAAO,iCAAiC;EACjE,4BAA4B,IAAI,eAAe;EAC/C,4BAA4B,IAAI,eAAe;;EAE/C,cAAc;EACd,yCAAyC,EAAE,iBAAiB;EAC5D,qCAAqC,MAAM,iBAAiB;EAC5D,sCAAsC,KAAK,iBAAiB;;EAE5D,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAE,cAAc;;EAE9C,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,uBAAuB,EAAE,eAAe;AAC1C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,wCAAwC;EACxC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B;;qCAEmC;EACnC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kEAAkE;EAClE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,+DAAoE;EACpE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,+DAAuE;EACvE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+DAAiE;EACjE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,2CAA2C;EAC3C,qCAAqC;EACrC,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2CAA2C;EAC3C,qCAAqC;EACrC,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,UAAU;;AAEV;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB","sourcesContent":[":root {\n  color-scheme: light;\n\n  --px-15: 15px;\n  --px-30: 30px;\n\n  /* 🎨 메인 컬러 (푸른 계열) */\n  --main-color: #5e62e5;\n  --main-color-light: #5a60fe; /* 기존 main-color1, main-color2, main-color7 */\n  --main-color-alt: #4a4ef5;    /* 기존 main-color4 */\n  --main-color-accent: #7377f7; /* 기존 main-color5, main-color8 */\n  --main-color-dark: #373a6a;   /* 기존 main-color6 */\n\n  /* ⚫ 검정/회색 계열 최적화 */\n  --color-black: #000;           /* 기존 black0 */\n  --color-darkest-gray: #121212;  /* 기존 black1, black6, black8 */\n  --color-dark-gray: #272a2f;     /* 기존 black5, black7 */\n  --color-gray: #3e3d3e;          /* 기존 black2~4, black9~11 */\n  --color-light-gray: #8b8b8b;    /* 기존 black14, black16~18, black20 */\n  --color-charcoal: #1c1e23;      /* 기존 black12, black13, black15 */\n  --color-black-brown: #221E18;   /* 기존 black21 */\n  --color-black-muted: #43433b;   /* 기존 black22 */\n\n  /* 🌫 반투명 검정 */\n  --color-black-opacity: rgba(0, 0, 0, 0.5); /* 기존 black-op0 */\n  --color-black-opacity-dark: #181818d4;     /* 기존 black-op2 */\n  --color-black-opacity-light: #33333399;    /* 기존 black-op3 */\n\n  /* ⚪ 밝은색 계열 */\n  --color-white: #fff;\n  --color-light-gray-bg: #f1f1f1; /* 기존 light2 */\n\n  /* 🟡 노랑 계열 */\n  --color-yellow: #F5AC1D; /* 기존 yellow0, yellow2 */\n  --color-orange: #F28C01; /* 기존 yellow1 */\n}\n\n.ratio {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.App {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background-color: var(--color-black);\n  color: var( --color-white);\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: border-box;\n  outline: none;\n  -webkit-tap-highlight-color: transparent;\n  user-select: none;\n}\n\n*::-webkit-scrollbar {\n  display: none;\n}\n\nhtml,\nbody {\n  height: 100%;\n  overflow: hidden;\n  margin: 0;\n  padding: 0;\n  overscroll-behavior: none;\n  -webkit-overflow-scrolling: touch;\n  touch-action: none;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.message {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--color-black-opacity);\n  z-index: 1000;\n}\n\n.message-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: auto;\n  min-width: 300px;\n  max-width: calc(100% - 40px);\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 15px;\n  padding: 15px 20px;\n  z-index: 100;\n  color: var( --color-white);\n}\n\n.message-modal.copy {\n  background-color: var(--color-darkest-gray);\n  border: 1px solid var(--main-color-light);\n}\n\n.loading {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  background: var( --color-black);\n  animation: splash_img .7s ease-in-out;\n}\n\n@keyframes splash_img {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.loading .img {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  /* top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); */\n  width: 100%;\n}\n\n.loading-3 {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 10;\n  font-size: 12px;\n  font-weight: 500;\n  width: 80%;\n}\n\n.loading-4 {\n  width: 100%;\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  font-weight: 500;\n}\n\n.loading-5 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.airdrop-text {\n  width: 100%;\n  position: absolute;\n  bottom: 0px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  font-weight: 500;\n}\n\n.loading-5-1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 45px;\n  height: 45px;\n  background-color: var(--color-gray);\n  border: 1px solid var(--color-gray);\n  border-radius: 50%;\n  font-size: 23px;\n}\n\n.buy-modal {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: auto;\n  min-width: 300px;\n  max-width: calc(100% - 40px);\n  /* height: 60px; */\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 15px 15px;\n  color: var( --color-white);\n  font-weight: 500;\n  z-index: 20000;\n}\n\n.buy-modal.copy {\n  border: 1px solid var(--color-gray);\n  background-color: var(--color-dark-gray);\n  box-shadow: 0 20px 25px -5px #0000001a, 0 10px 10px -5px #0000000a;\n  animation: Modal_opacityIn .4s ease-in-out;\n}\n\n@keyframes Modal_opacityIn {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, 0px);\n  }\n}\n\n.fontNumber {\n  font-family: \"Courier-Bold\";\n}\n\n@font-face {\n  font-family: 'Courier-Regular';\n  src: url('/public/fonts/ttf/Courier-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Courier-BoldItalic';\n  src: url('/public/fonts/ttf/Courier-BoldItalic.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Courier-Bold';\n  src: url('/public/fonts/ttf/Courier-Bold.ttf') format('truetype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n.loading-4-1 {\n  width: 150px;\n  margin: 0 auto;\n  padding: 8px 12px;\n  background-color: var(--color-darkest-gray);\n  border: 2px solid var(--color-yellow);\n  color: var(--color-yellow);\n  font-weight: bold;\n  font-size: 18px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 0px 15px 3px var(--color-yellow);\n}\n\n.airdrop-text-1 {\n  margin: 0 auto;\n  /* padding: 8px 10px; */\n  background-color: var(--color-darkest-gray);\n  border: 2px solid var(--color-yellow);\n  color: var(--color-yellow);\n  font-weight: bold;\n  font-size: 15px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 0px 15px 3px var(--color-yellow);\n}\n\n.web {\n  /* width: 100vw; */\n  height: 100vh;\n  padding: 20px;\n  background-color: var( --color-black);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.web-box {}\n\n.web-qr {\n  width: 240px;\n  height: 240px;\n  padding: 15px;\n  border-radius: 10px;\n  background-color: var( --color-white);\n  margin: 20px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
